export default "__VITE_ASSET__D0Ij9S6M__"